// extracted by mini-css-extract-plugin
export default {"icon":"BTN_INFO_ZAMOWIENIA_icon__RCu81","icon2":"BTN_INFO_ZAMOWIENIA_icon2__KSXFQ"};